var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"companyIndustry"}},[_c('Header'),_c('div',{staticStyle:{"width":"1920px","height":"500px","border":"1px solid darkblue"}},[_vm._v(" 444 ")]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }